import React from "react";
import { observer } from "mobx-react";

const ListContainer = observer((props) => (
  <div className={`list-container ${props.className}`}>{props.children}</div>
));

export default ListContainer;
